import React, { useEffect, useState } from "react";
import ContentBankItemList from "./ContentBankItemList/ContentBankItemList";
import { ClassificationEnum } from "../../../models/ClassificationContentBankEnum";
import TabsContentBank from "./TabsContentBank";
import TypeMenuContentBank from "./TypeMenuContentBank";
import classes from './ContentBank.module.css';
import LeftSidePopup from "../../UI/LeftSidePopup";
import { ContentBankTabsEnum } from "../../../models/ContentBankTabsEnum";
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import { contentBankApi } from "../../../utils";
import { useDispatch, useSelector } from "react-redux";
import { ObjectTypeEnum } from "../../../models/ObjectTypeEnum";

const ContentBank = ({ children, listFilter, setAddItem, addItem, setMyMaterialList, fromPopup, selectedMaterial, setSelectedMaterial }) => {

    const [dataAPI, setDataAPI] = useState({ classificationId: ClassificationEnum.project, tabs: 1, free: null, curriculum: null, standard: null, dependencyStandard: null, ideId: null, lang: null, file: null, tag: null, sort: null, pageNum: 0, refObjectType: ObjectTypeEnum.Application });
    const [contentBankItemList, setContentBankItemList] = useState();
    const [current, setCurrent] = useState(0)
    const dispatch = useDispatch()
    const texts = useSelector(state => state.translate.texts);
    const { user } = useSelector(state => state.auth);
    const uiData = useSelector((state) => state.general.uiData);

    function handleChange(field, value) {
        let newDataApi = { ...dataAPI, [field]: value }
        setDataAPI({ ...dataAPI, [field]: value })
        if ((newDataApi.classificationId === ClassificationEnum.project || newDataApi.classificationId === ClassificationEnum.lesson) && newDataApi.tabs === ContentBankTabsEnum.myMaterials) {
            setMyMaterialList(null);
            setContentBankItemList(null)
            children[current].props.handleChange(newDataApi, newDataApi.classificationId);
        }
        else {
            setContentBankItemList(null)
            setMyMaterialList(null);
            if (newDataApi.classificationId === ClassificationEnum.auxiliary && newDataApi.tabs === ContentBankTabsEnum.myMaterials) {
                setContentBankItemList([])
            }
            else {
                let data = {
                    classification: newDataApi.classificationId,
                    searchText: newDataApi.free,
                    contentType: newDataApi.file,
                    lang: newDataApi.lang === texts.without ? null : newDataApi.lang,
                    pageNum: newDataApi.pageNum,
                    rowsNum: 50,
                    ideId: newDataApi.classificationId === ClassificationEnum.auxiliary ? null : newDataApi.ideId
                }
                if (newDataApi.tabs === ContentBankTabsEnum.sharedMaterials) data.userId = user.id;
                if (newDataApi.tabs === ContentBankTabsEnum.headquartersRepository) data.userId = uiData.headquarters[0];
                if (newDataApi.tabs === ContentBankTabsEnum.nationalRepository) data.userId = null;
                contentBankApi.contentBankFilterRangePost({ contentBankRangeFilter: data }, (error, resdata, response) => {
                    if (error) {
                        setContentBankItemList([])
                        dispatch(throwApiError({ userMessage: texts.MessageTitleErrorOccurred, error: error, statusCode: response?.statusCode, message: "contentBankRangeFilter " + error.message, level: 2, component: "ContentBank", line: 46 }))
                    }
                    else {
                        setContentBankItemList(resdata)
                    }
                })
            }
        }
    }

    function handeleShareContentBankItem() {
        if (uiData) {
            let data = { ...addItem }
            if (dataAPI.tabs === ContentBankTabsEnum.sharedMaterials) data.userId = user.id;
            if (dataAPI.tabs === ContentBankTabsEnum.headquartersRepository) data.userId = uiData.headquarters[0];
            if (dataAPI.tabs === ContentBankTabsEnum.nationalRepository) data.userId = null;
            contentBankApi.contentBankAddPost(data, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.addItemError, error: error, statusCode: response?.statusCode, message: "contentBankPost" + error.message, level: 2, component: "ContentBank", line: 62 }))
                    //ToDO Api 
                } else {
                    let itemToAdd = { ...addItem };
                    if (typeof (data.file) == typeof ({})) itemToAdd.url = URL.createObjectURL(data.file);
                    if (typeof (data.thumbnail) == typeof ({})) itemToAdd.thumbnail = URL.createObjectURL(data.thumbnail);
                    setContentBankItemList([...contentBankItemList, { ...itemToAdd, id: response.body }])
                    setAddItem(null)
                }
            })
        }
    }

    useEffect(() => {
        if (addItem) {
            handeleShareContentBankItem()
        }
    }, [addItem, uiData])

    // const updatePageNumAndFetchData = async () => {
    //     let newDataApi = { ...dataAPI, pageNum: dataAPI.pageNum + 1 }
    //     setDataAPI({ ...dataAPI, pageNum: dataAPI.pageNum + 1 })
    //     await fetchData(newDataApi)
    // }

    return (
        <div className={classes.ContentBank}>
            {uiData && <div className={`${classes.ContentBankContainer} ${children[current].props?.fromPopup ? classes.ContentBankContainerInPopup : ''}`}>

                <LeftSidePopup>
                    <TypeMenuContentBank handleChange={handleChange} setCurrent={setCurrent} current={current} listFilter={listFilter} fromPopup={children[current].props?.fromPopup} selected={dataAPI.refObjectType} />
                </LeftSidePopup>

                <div className={classes.ContentBankContent}>
                    <TabsContentBank handleChange={handleChange} dataAPI={dataAPI} fromPopup={fromPopup} />
                    <ContentBankItemList
                        contentBankItemList={contentBankItemList}
                        setContentBankItemList={setContentBankItemList}
                        warrperData={children[current].props}
                        setContentBankItem={(value) => children[current].props.itemClick(value)}
                        dataAPI={dataAPI}
                        handleChange={handleChange}
                        selectedMaterial={selectedMaterial}
                        setSelectedMaterial={setSelectedMaterial} />
                </div>
            </div>}
        </div>
    )
}

export default ContentBank;